import React from 'react';
import { Route } from 'react-router-dom';

import { WithNotFound } from '../errors';
import { CustomersPage } from './customers';
import { CustomerPage } from './customerDetails';

const CustomersRoutes = () => (
    <WithNotFound>
        <Route path={`/:accountId/customers`} exact component={CustomersPage} />
        <Route path={`/:accountId/customers/:customerId`} exact component={CustomerPage} />
    </WithNotFound>
);

export default CustomersRoutes;
